"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpentrackOperationCodeDto = void 0;
class OpentrackOperationCodeDto {
    constructor(params) {
        this.enterpriseCode = "";
        this.companyNumber = "";
        this.operationCode = "";
        this.description = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.enterpriseCode = params.enterpriseCode;
        this.companyNumber = params.companyNumber;
        this.operationCode = params.operationCode;
        this.description = params.description;
    }
}
exports.OpentrackOperationCodeDto = OpentrackOperationCodeDto;
//# sourceMappingURL=OpentrackOperationCodeDto.js.map